<template>
  <a-modal :centered="true" :destroyOnClose="true" :loading="loading" :visible="visible" title="库房出库规则" width="50%" @cancel="handleCancel" @ok="handleOk">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="rule" :rules="rules" :wrapper-col="wrapperCol">
      <a-row>
        <a-col span="8">
          <a-form-model-item label="包装类型" prop="packType">
            <a-select v-model="rule.packType" :options="packTypes" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col span="8">
          <a-form-model-item ref="storageRoom" label="库房" prop="storageRoom">
            <a-input v-model="rule.storageRoom.name" allowClear @change="(e)=>change(e,'storageRoom')" @dblclick="search('storageRoomModal',{physical:true})" @pressEnter="search('storageRoomModal',{physical:true})"/>
            <storage-room-modal ref="storageRoomModal" @change="(e)=>change(e[0],'storageRoom')"/>
          </a-form-model-item>
        </a-col>
        <a-col span="8">
          <a-form-model-item label="发货顺序" prop="shipOrder">
            <a-input-number v-model="rule.shipOrder" :min="1" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="8">
          <a-form-model-item label="货主" prop="storer">
            <a-input v-model="rule.storer.name" allowClear @change="(e)=>change(e,'storer')" @dblclick="search('storerModal',{available:true})" @pressEnter="search('storerModal',{available:true})"/>
            <storer-modal ref="storerModal" @change="(e)=>change(e[0],'storer')"/>
          </a-form-model-item>
        </a-col>
        <a-col span="8">
          <a-form-model-item label="订单类型" prop="orderType">
            <a-input v-model="rule.orderType.name" allowClear @change="(e)=>change(e,'orderType')" @dblclick="search('orderTypeModal',{available:true,operationType:2})" @pressEnter="search('orderTypeModal',{available:true,operationType:2})"/>
            <order-type-modal ref="orderTypeModal" @change="(e)=>change(e[0],'orderType')"/>
          </a-form-model-item>
        </a-col>
        <a-col span="8">
          <a-form-model-item label="商品类型" prop="itemType">
            <a-input v-model="rule.itemType.name" allowClear @change="(e)=>change(e,'itemType')" @dblclick="search('itemTypeModal',{available:true})" @pressEnter="search('itemTypeModal',{available:true})"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <field-modal ref="itemTypeModal" :show-name="true" :show-no="true" :show-value="false" :title="$t('business.label.itemType')" no="ITEM_TYPE" @change="(e)=>change(e[0],'itemType')"/>
  </a-modal>
</template>

<script>
import { save } from '@/api/Api'
import { ShipmentRule } from '@/api/dto/config/ShipmentRule'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import StorerModal from '@/views/modal/StorerModal.vue'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'
import { Identifier } from '@/api/dto/Identifier'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import FieldModal from '@/views/modal/FieldModal.vue'

export default {
  name: 'StorageRoomShipmentRuleModal',
  components: { FieldModal, OrderTypeModal, StorerModal, StorageRoomModal },
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      visible: false,
      loading: false,
      rule: new ShipmentRule(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        'packType': [{ required: true, message: '包装类型不能为空' }],
        'storageRoom': [{ required: true, message: '库房不能为空' }],
        'shipOrder': [{ required: true, message: '发货顺序不能为空' }]
      }
    }
  },
  props: {
    packTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    add(storageRoom) {
      this.visible = true
      this.rule = new ShipmentRule()
      this.rule.storageRoom = new StorageRoom(storageRoom)
    },
    edit(record) {
      this.visible = true
      this.rule = new ShipmentRule(record)
    },
    search(refName, args) {
      this.$refs[refName].open(args)
    },
    change(changeData, fieldName) {
      this.rule[fieldName] = new Identifier(changeData)
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          const rule = this.rule.toJSONObject()
          rule.warehouse = this.warehouse
          save('shipmentRulePersister', rule).then(res => {
            if (res.success) {
              this.rule = new ShipmentRule(res.result)
              this.$success({
                title: '提示',
                content: '保存成功',
                centered: true
              })
              this.$emit('saveSuccess')
              this.handleCancel()
            }
          }).finally(() => this.loading = false)
        }
      })
    },
    handleOk() {
      this.save()
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>